import { SetStateAction } from 'react';
import { connect } from 'react-redux';
import { setSearchSectionPage } from 'redux/modules/search';
import { RootState } from 'redux/modules/types';
import {
  SEARCH_FEEDBACK_PER_PAGE_DETAIL,
  SEARCH_FEEDBACK_PER_PAGE_MASTER,
} from 'utils/config';
import { getPageCount } from 'utils/getPageCount';
import { OwnProps } from './types';

const mapStateToProps = (state: RootState, { isDetail }: OwnProps) => ({
  available: state.search.available.feedback,
  count: state.search.count.feedback,
  items: state.search.ids.feedback
    .map((id) => state.search.byId.feedback[id])
    .filter((it): it is NonNullable<typeof it> => !!it),
  loading: state.search.loading.feedback,
  page: state.search.page.feedback,
  pageCount: getPageCount(
    state.search.count.feedback,
    isDetail
      ? SEARCH_FEEDBACK_PER_PAGE_DETAIL
      : SEARCH_FEEDBACK_PER_PAGE_MASTER,
  ),
});

const mapDispatchToProps = {
  setPage: (page: SetStateAction<number>) =>
    setSearchSectionPage({
      page,
      section: 'feedback',
    }),
};

export default connect(mapStateToProps, mapDispatchToProps);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;
